<template>
  <div>
    <woot-modal-header-v2
      :header-title="$t('AGENT_MGMT.DISCONNECT.CONFIRM.TITLE')"
    >
      <template #titleIcon>
        <span class="material-symbols-outlined text-icon-primary font-[300]">
          person_remove
        </span>
      </template>
    </woot-modal-header-v2>
    <div class="px-6">
      <div
        class="flex flex-row items-center"
        v-html="
          $t('AGENT_MGMT.DISCONNECT.CONFIRM.MESSAGE', { agentName: agent.name })
        "
      />
    </div>
    <div class="flex flex-row justify-end gap-2 pt-7 pb-6 px-6 w-full">
      <woot-button
        color-scheme="secondary"
        class="cancel-btn button clear text-base px-5 py-[11px] leading-[20px] h-[48px] font-[400]"
        @click="closeDisconnectPopup"
      >
        {{ $t('AGENT_MGMT.DISCONNECT.CONFIRM.NO') }}
      </woot-button>

      <woot-button
        color-scheme=""
        class="button-filled text-base px-5 py-[11px] font-[400] h-[unset] bg-[#D97706] hover:bg-[#D97706] focus:bg-[#D97706]"
        variant=""
        @click.native.prevent="confirmDisconnect"
      >
        {{ $t('AGENT_MGMT.DISCONNECT.CONFIRM.YES') }}
      </woot-button>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    closeDisconnectPopup: {
      type: Function,
      required: true,
    },
    agent: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      loading: false,
    };
  },
  methods: {
    confirmDisconnect() {
      this.loading = true;
      this.closeDisconnectPopup();
      this.onDisconnectClick(this.agent.id);
    },
    async onDisconnectClick() {
      try {
        await this.$store.dispatch('agents/disconnect', this.agent.id);
        bus.$emit(
          'newToastMessage',
          this.$t('AGENT_MGMT.DISCONNECT.API.SUCCESS_MESSAGE')
        );
      } catch (error) {
        bus.$emit(
          'newToastMessage',
          this.$t('AGENT_MGMT.DISCONNECT.API.ERROR_MESSAGE')
        );
      }
    },
  },
};
</script>
